import {useEffect, useRef, useState, type ReactNode} from 'react';
import {tr} from '../i18n/idioma';

// Clase de cada opcion de la lista: ancho completo, texto a la izquierda.
export const OPCION_DE_MENU =
  'block w-full rounded px-3 py-1.5 text-left text-sm text-tinta hover:bg-papel disabled:opacity-50';

// Lista desplegable "Herramientas" que agrupa las acciones de una pantalla
// (Daniel, 8/10/2026). Se cierra con un clic afuera o con Escape; cada opcion
// recibe `cerrar` para cerrarla despues de usarla. Las que abren su propio
// panel (Columnas) la dejan abierta.
export function MenuDeHerramientas({children}: {children: (cerrar: () => void) => ReactNode}) {
  const [abierto, setAbierto] = useState(false);
  const caja = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!abierto) return;
    const fuera = (evento: MouseEvent) => {
      if (caja.current && !caja.current.contains(evento.target as Node)) setAbierto(false);
    };
    const tecla = (evento: KeyboardEvent) => {
      if (evento.key === 'Escape') setAbierto(false);
    };
    document.addEventListener('mousedown', fuera);
    document.addEventListener('keydown', tecla);
    return () => {
      document.removeEventListener('mousedown', fuera);
      document.removeEventListener('keydown', tecla);
    };
  }, [abierto]);

  return (
    <div ref={caja} className="relative">
      <button
        type="button"
        onClick={() => setAbierto(a => !a)}
        aria-expanded={abierto}
        aria-haspopup="true"
        className="rounded-md border border-linea bg-white px-3 py-1.5 text-sm hover:bg-papel"
      >
        {tr('🛠 Herramientas', '🛠 Tools')} ▾
      </button>
      {abierto && (
        <div
          role="group"
          aria-label={tr('Herramientas', 'Tools')}
          className="absolute right-0 z-20 mt-1 flex w-64 flex-col gap-0.5 rounded-lg border border-linea bg-white p-1 shadow-lg"
        >
          {children(() => setAbierto(false))}
        </div>
      )}
    </div>
  );
}
